import { Title, Box, Group, Stack, Grid } from '@mantine/core';
import { useNavigate, useParams } from 'react-router-dom';
import { PageWithBreadcrumbs } from '../../components/layout/PageWithBreadcrumbs';
import { ContainerWhite } from '../../components/core/ContainerWhite/ContainerWhite';
import { AfaButton, AfaFieldDisplay, AfaCommentHistory, AfaPageLoader, AfaDocumentHistory } from '../../components/ui';
import { InfoInteresseModal } from '../../components/Modals/InfoInteresseModal';
import { useState, useEffect, useRef } from 'react';
import { CancelTramitModal } from '../../components/Modals/CancelTramitModal/CancelTramitModal';
import { tramesesGroupedType } from "../../interface/trameses";
import { DeleteTramitModal } from '../../components/Modals/DeleteTramitModal/DeleteTramitModal';
import { UploadDocumentacioTramitModal } from '../../components/Modals/UploadDocumentacioTramitModal/UploadDocumentacioTramitModal';
import moment from 'moment';

export function TramitsDetall(props: any) {
  const navigate = useNavigate();
  const { id } = useParams();
  const [guid, setGuid] = useState("");
  const [modalOpened, setModalOpened] = useState<boolean>(false);
  const [cancelModalOpened, setCancelModalOpened] = useState<boolean>(false);
  const [deleteModalOpened, setDeleteModalOpened] = useState<boolean>(false);

  const [uploadDocModalOpened, setUploadDocModalOpened] = useState<boolean>(false);

  const [loading, setLoading] = useState<boolean>(true);
  const [state, setDetallState] = useState("");
  const [data, setData] = useState(null as any);
  const [otherReceivers, setOtherReceivers] = useState<string[]>([]);
  const [comments, setComments] = useState<any[]>([]);
  const [documents, setDocuments] = useState([]);
  const [documentsAfa, setDocumentsAfa] = useState([]);
  const [groups, setGroups] = useState<tramesesGroupedType[]>([]);
  const formRef = useRef<HTMLFormElement>(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sendDocs = params.get("sendDocs");

    props.apiService
      .GetTramitsById(id, props.entity.lookupId)
      .then((data: any) => {
        setData(data);
        setDetallState(data.state);
        setOtherReceivers(Array.isArray(data.otherReceivers) ? data.otherReceivers : []);
        setComments(Array.isArray(data.comments) ? data.comments : []);
        setDocuments(Array.isArray(data.docs) ? data.docs : []);
        setDocumentsAfa(Array.isArray(data.docsAFA) ? data.docsAFA : []);
        setGuid(data.guid)

        if (sendDocs && (data.state === "Pendent rebre documentació" || data.state === "Pendent rebre pagament" || data.fase === "Validació i Anàlisi")) setUploadDocModalOpened(true);

        try {
          const parsed: tramesesGroupedType[] = JSON.parse(data.formJson);
          if (Array.isArray(parsed)) {
            setGroups(parsed);
          } else {
            setGroups([]);
          }
          setLoading(false);
        } catch (err) {
          setGroups([]);
          setLoading(false);
        }
      })
      .catch((error: any) => {
        console.error("Error:", error);
      });
  }, []);


  const handleDownload = (fileName: string, base64Data: any) => {
    // Convertimos el Base64 a un Blob
    const byteCharacters = atob(base64Data);
    const byteNumbers = Array.from(byteCharacters, char => char.charCodeAt(0));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });

    // Creamos un enlace temporal y forzamos la descarga
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();

    // Liberamos memoria
    URL.revokeObjectURL(link.href);
  };

  return (
    <PageWithBreadcrumbs>
      <Title order={1}>Detall del Tràmit: {guid}</Title>
      <ContainerWhite>
        {loading ?
          <AfaPageLoader description="Carregant el detall..."></AfaPageLoader>
          :
          <>
            <Box bg="brand.0" p="md" style={{ borderRadius: '8px' }}>
              <Group gap="xl" align="flex-start">
                <AfaFieldDisplay
                  label="Entitat"
                  value={props.entity != null ? props.entity.lookupValue : ''}
                  style={{ flex: 1 }}
                />
                <AfaFieldDisplay
                  label="Informació d'interès"
                  button={{
                    text: 'Consultar informació',
                    onClick: () => setModalOpened(true),
                    id: 'btn-consultar-info'
                  }}
                  style={{ flex: 1 }}
                />
                <AfaFieldDisplay
                  label="Estat"
                  badge={{
                    color: {
                      'En revisió': 'yellow',
                      'Pendent rebre documentació': 'orange',
                      'Cancel·lat entitat': 'lilac',
                      'Rebutjat AFA': 'red',
                      'Finalitzat': 'green',
                      'Esborrany': 'blue'
                    }[state] ?? 'yellow' as any,
                    variant: "filled",
                    text: state
                  }}
                  style={{ flex: 1 }}
                />
              </Group>
            </Box>

            <Box mt="md">
              <Stack gap="md">
                <Group align="flex-start">
                  <AfaFieldDisplay
                    label="Vull iniciar un tràmit referent a una"
                    value={data.filial.lookupId !== -1 ? "Filial" : "Entitat"}
                    style={{ flex: 1 }}
                  />
                  {data.filial.lookupId !== -1 &&
                    <AfaFieldDisplay
                      label="Filial"
                      value={data.filial.lookupValue}
                      style={{ flex: 1 }}
                    />
                  }
                </Group>

                <Group align="flex-start">
                  <AfaFieldDisplay
                    label="Tipus de procés"
                    value={data?.processType}
                    style={{ flex: 1 }}
                  />
                  <AfaFieldDisplay
                    label="Procés"
                    value={data?.tramitType?.lookupValue}
                    style={{ flex: 1 }}
                  />
                </Group>

                <Group align="flex-start">
                  <AfaFieldDisplay
                    label="Id del procés anterior"
                    value={data?.relatedTramits?.lookupValue}
                    style={{ flex: 1 }}
                  >
                  </AfaFieldDisplay>
                  <AfaFieldDisplay
                    label="Altres destinataris"
                    value={otherReceivers?.join(", ") ?? ""}
                    style={{ flex: "0 0 calc(50% - 8px)" }}
                  />
                </Group>
                {data.cancelledReason && (state == "Rebutjat AFA" || state == "Cancel·lat entitat") &&
                  <Group align="flex-start" wrap="nowrap" gap="md">
                    <AfaFieldDisplay
                      label="⚠️ Motiu de cancel·lació"
                      value={data.cancelledReason}
                    />
                  </Group>
                }

                {data.dateTermini && (state == "Pendent rebre documentació" || state == "Pendent rebre pagament") &&
                  <Group align="flex-start" wrap="nowrap" gap="md">
                    <AfaFieldDisplay
                      label="⚠️ Data termini"
                      value={moment(data.dateTermini).format('YYYY-MM-DD')}
                    />
                  </Group>
                }
              </Stack>
            </Box>

            {/* Comentaris */}
            <Title order={3} mt={'xl'}>Històric comentaris amb AFA</Title>
            {/* <Box mt="xs"> */}
            <AfaCommentHistory comments={comments} />
            {/* </Box> */}

            <p></p>
            {/* Formulari */}
            <form ref={formRef} style={{ marginTop: '40px' }}>
              {groups.length > 0 && (
                <div style={{ marginBottom: '20px' }}>
                  <Title order={3}>Formulari</Title>
                  <hr />
                </div>
              )}

              <Group align="flex-start">
                <div style={{ flex: 1 }}>
                  {groups.map((group) => (
                    <div
                      key={group.groupName}
                      style={{ marginBottom: "24px" }}
                    >
                      <Title order={3}>{group.groupName}</Title>
                      <Box mt="xs">
                        <Stack gap="xs">
                          <Grid gutter="md">
                            {group.fields
                              .sort((a, b) => a.order - b.order)
                              .map((field, index) => {
                                let span = 12;
                                if (field.colsNumber === 2) span = 6;
                                if (field.colsNumber === 3) span = 4;

                                return (
                                  <Grid.Col
                                    key={`${group.groupName}-${field.title}`}
                                    span={span}
                                  >
                                    <AfaFieldDisplay
                                      label={field.title}
                                      value={field.value?.toString()}
                                      style={{ flex: 1 }}
                                    />
                                  </Grid.Col>
                                );
                              })}
                          </Grid>
                        </Stack>
                      </Box>
                    </div>
                  ))}
                </div>
              </Group>
            </form>

            {/* Documentació */}
            <Title order={3} mt="xl">Documents AFA</Title>
            <AfaDocumentHistory
              documents={documentsAfa}
              onDownload={handleDownload}
              emptyMessage="No hi ha documents de AFA per mostrar."
              maxHeight="260px"
            />

            <Title order={3} mt="xl">Documents</Title>
            <AfaDocumentHistory
              documents={documents}
              onDownload={handleDownload}
              emptyMessage="No hi ha documents del usuari per mostrar."
              maxHeight="260px"
            />


          </>
        }
      </ContainerWhite>

      {/* Botones de acción */}
      <Group justify="space-between" mt="xs">
        <AfaButton id="btn-tornar" variant="outline" onClick={() => navigate('/tramits/consultar')}>
          Tornar
        </AfaButton>
        <Group gap="md">
          {state === "En revisió" &&
            <AfaButton id="btn-cancelar" variant="outline" color="red" onClick={() => setCancelModalOpened(true)}>
              Cancel·lar
            </AfaButton>
          }
          {state === "Esborrany" && data.createdBy.lookupId !== -1 && data.createdBy.lookupValue === props.user?.user?.titulo &&
            <AfaButton
              id="btn-enviar-documentacio"
              variant="filled"
              onClick={() => { setDeleteModalOpened(true) }}
            >
              Esborrar
            </AfaButton>
          }
          {
            data != null && data.nextTramitType != null && data.state == "Finalitzat" &&
            <AfaButton id="btn-continuar-proces" variant="filled" onClick={() => {
              navigate(`/tramits/iniciar-nou`, {
                state: {
                  tramitType: data.nextTramitType,
                  idType: data.id,
                  from: 'editar',
                }
              })
            }}>
              Continuar procés
            </AfaButton>
          }

          {(state === "Pendent rebre documentació" || state === "Pendent rebre pagament" || data?.fase === "Validació i Anàlisi") &&
            <AfaButton
              id="btn-enviar-documentacio"
              variant="filled"
              onClick={() => { setUploadDocModalOpened(true) }}
            >
              Enviar documentació
            </AfaButton>
          }

          {/* <AfaButton id="btn-enviar-documentacio" variant="filled" onClick={() => { }}>
            Enviar documentació
          </AfaButton> */}
        </Group>
      </Group>

      {/* Modal de información */}
      <InfoInteresseModal
        opened={modalOpened}
        onClose={() => setModalOpened(false)}
      />

      {/* Modal de cancelación */}
      <DeleteTramitModal
        apiService={props.apiService}
        opened={deleteModalOpened}
        onClose={() => {
          setDeleteModalOpened(false)
        }}
        tramitId={id}
      />
      {/* Modal de cancelación */}
      <CancelTramitModal
        apiService={props.apiService}
        opened={cancelModalOpened}
        onClose={() => setCancelModalOpened(false)}
        tramitId={id}
      />

      {/* Modal pujada documentació */}
      <UploadDocumentacioTramitModal
        apiService={props.apiService}
        opened={uploadDocModalOpened}
        onClose={() => setUploadDocModalOpened(false)}
        tramitId={id}
        tramitState={state}
        entityId={props.entity.lookupId}
      />

    </PageWithBreadcrumbs>
  );
}
